<div class="app-shell">
  <!-- 애니메이션 배경 — 앱 셸에 한 벌만 둔다.
       페이지마다 갖고 있으면 라우팅할 때 DOM 이 파괴·재생성되며 애니메이션이
       0% 로 리셋되어 화면이 번쩍인다. 여기 두면 라우팅과 무관하게 계속 흐른다. -->
  <div class="space-drift" aria-hidden="true">
    <div class="space-drift__mist space-drift__mist--cold"></div>
    <div class="space-drift__mist space-drift__mist--warm"></div>
    <div class="space-drift__aurora"></div>
  </div>

  <!-- 테마 전환 라디오 (숨김) — html:has(#theme-N:checked) CSS 셀렉터로 전역 테마 전환 -->
  <input type="radio" class="theme-radio" id="theme-1" name="app-theme" value="1"
         [checked]="theme === '1'" (change)="onThemeChange('1')">
  <input type="radio" class="theme-radio" id="theme-6" name="app-theme" value="6"
         [checked]="theme === '6'" (change)="onThemeChange('6')">

  <input
    *ngIf="showTopNav"
    class="app-shell__nav-toggle"
    id="app-shell-nav-toggle"
    type="checkbox"
    aria-label="메뉴 열기 닫기"
  />
  <label *ngIf="showTopNav && hasSideNav" class="app-shell__hamburger" for="app-shell-nav-toggle" aria-label="메뉴 열기 닫기">
    <span></span>
    <span></span>
    <span></span>
  </label>

  <header *ngIf="showTopNav" class="top-nav" id="sidebar-root" data-nav-active="">
    <div class="top-nav__inner">
      <div class="top-nav__lead">
        <div class="top-nav__brand">
          <a class="top-nav__logo" href="javascript:void(0)" aria-label="메인으로 이동"
           (click)="goToLink('/main'); $event.preventDefault()">
            <img class="top-nav__logo-img" src="assets/images/logo.png" width="120" height="30" alt="kt alpha" />
          </a>
        </div>

        <div class="top-nav__scroll">
        <div
          class="top-nav__menu-wrap"
          [class.top-nav__menu-wrap--suppress]="megaMenuSuppressed"
          (mouseleave)="onMegaMenuMouseLeave()"
        >
          <nav class="top-nav__menu" aria-label="주 메뉴">
            <ul class="top-nav__list">
              <li class="top-nav__item" *ngIf="showMenu('/user')">
                <a
                  href="javascript:void(0)"
                  class="top-nav__link"
                  [class.top-nav__link--active]="isNavActive('/user')"
                  (click)="goToLink('/user/organization'); $event.preventDefault()"
                >
                  <mat-icon class="top-nav__link-icon" aria-hidden="true">person</mat-icon>
                  <span class="top-nav__link-text">사용자</span>
                </a>
                <div class="top-nav__mega-col">
                  <ul class="top-nav__sub-list">
                    <li *ngIf="showMenu('/user/organization')">
                      <a
                        class="top-nav__sub-link"
                        href="javascript:void(0)"
                        [class.top-nav__sub-link--active]="isNavActive('/user/organization')"
                        (click)="goToLink('/user/organization'); $event.preventDefault()"
                      >조직관리</a>
                    </li>
                    <li *ngIf="showMenu('/user/management')">
                      <a
                        class="top-nav__sub-link"
                        href="javascript:void(0)"
                        [class.top-nav__sub-link--active]="isNavActive('/user/management')"
                        (click)="goToLink('/user/management'); $event.preventDefault()"
                      >사용자관리</a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="top-nav__item" *ngIf="showMenu('/access')">
                <a
                  href="javascript:void(0)"
                  class="top-nav__link"
                  [class.top-nav__link--active]="isNavActive('/access')"
                  (click)="goToLink('/access/permission'); $event.preventDefault()"
                >
                  <mat-icon class="top-nav__link-icon" aria-hidden="true">lock_open</mat-icon>
                  <span class="top-nav__link-text">출입관리</span>
                </a>
                <div class="top-nav__mega-col">
                  <ul class="top-nav__sub-list">
                    <li *ngIf="showMenu('/access/permission')">
                      <a
                        class="top-nav__sub-link"
                        href="javascript:void(0)"
                        [class.top-nav__sub-link--active]="isNavActive('/access/permission')"
                        (click)="goToLink('/access/permission'); $event.preventDefault()"
                      >출입권한</a>
                    </li>
                    <li *ngIf="showMenu('/access/history')">
                      <a
                        class="top-nav__sub-link"
                        href="javascript:void(0)"
                        [class.top-nav__sub-link--active]="isNavActive('/access/history')"
                        (click)="goToLink('/access/history'); $event.preventDefault()"
                      >출입이력</a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="top-nav__item" *ngIf="showMenu('/visit')">
                <a
                  href="javascript:void(0)"
                  class="top-nav__link"
                  [class.top-nav__link--active]="isNavActive('/visit')"
                  (click)="goToLink('/visit'); $event.preventDefault()"
                >
                  <svg
                    class="top-nav__link-icon"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <rect x="3" y="5" width="18" height="14" rx="2" />
                    <circle cx="9" cy="12" r="2" />
                    <path d="M14 10h4" />
                    <path d="M14 14h3" />
                  </svg>
                  <span class="top-nav__link-text">방문증</span>
                </a>
                <div class="top-nav__mega-col">
                  <ul class="top-nav__sub-list">
                    <li *ngIf="showMenu('/visit/visit-info')"><a class="top-nav__sub-link" href="javascript:void(0)" [class.top-nav__sub-link--active]="isNavActive('/visit/visit-info')" (click)="goToLink('/visit/visit-info'); $event.preventDefault()">방문증관리</a></li>
                    <li *ngIf="showMenu('/visit/visit-entrance')"><a class="top-nav__sub-link" href="javascript:void(0)" [class.top-nav__sub-link--active]="isNavActive('/visit/visit-entrance')" (click)="goToLink('/visit/visit-entrance'); $event.preventDefault()">방문증 출입이력</a></li>
                  </ul>
                </div>
              </li>
              <li class="top-nav__item" *ngIf="showMenu('/device')">
                <a
                  href="javascript:void(0)"
                  class="top-nav__link"
                  [class.top-nav__link--active]="isNavActive('/device')"
                  (click)="goToLink('/device'); $event.preventDefault()"
                >
                  <mat-icon class="top-nav__link-icon" aria-hidden="true">stay_primary_landscape</mat-icon>
                  <span class="top-nav__link-text">장치관리</span>
                </a>
                <div class="top-nav__mega-col">
                  <ul class="top-nav__sub-list">
                    <li *ngIf="showMenu('/device')"><a class="top-nav__sub-link" href="javascript:void(0)" [class.top-nav__sub-link--active]="isNavActive('/device')" (click)="goToLink('/device'); $event.preventDefault()">장치목록</a></li>
                  </ul>
                </div>
              </li>
              <li class="top-nav__item" *ngIf="showMenu('/admin')">
                <a
                  href="javascript:void(0)"
                  class="top-nav__link"
                  [class.top-nav__link--active]="isNavActive('/admin')"
                  (click)="goToLink('/admin'); $event.preventDefault()"
                >
                  <mat-icon class="top-nav__link-icon" aria-hidden="true">admin_panel_settings</mat-icon>
                  <span class="top-nav__link-text">관리자</span>
                </a>
                <div class="top-nav__mega-col">
                  <ul class="top-nav__sub-list">
                    <li *ngIf="showMenu('/admin/settings')"><a class="top-nav__sub-link" href="javascript:void(0)" [class.top-nav__sub-link--active]="isNavActive('/admin/settings')" (click)="goToLink('/admin/settings'); $event.preventDefault()">설정</a></li>
                    <li *ngIf="showMenu('/admin/management')"><a class="top-nav__sub-link" href="javascript:void(0)" [class.top-nav__sub-link--active]="isNavActive('/admin/management')" (click)="goToLink('/admin/management'); $event.preventDefault()">관리자관리</a></li>
                    <li *ngIf="showMenu('/admin/key-management')"><a class="top-nav__sub-link" href="javascript:void(0)" [class.top-nav__sub-link--active]="isNavActive('/admin/key-management')" (click)="goToLink('/admin/key-management', 'key-tab-management'); $event.preventDefault()">키관리</a></li>
                    <li *ngIf="showMenu('/admin/system-log')"><a class="top-nav__sub-link" href="javascript:void(0)" [class.top-nav__sub-link--active]="isNavActive('/admin/system-log')" (click)="goToLink('/admin/system-log'); $event.preventDefault()">시스템로그</a></li>
                  </ul>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      </div>

      <div class="top-nav__spacer" aria-hidden="true"></div>

      <div class="top-nav__extras">
        <!-- 테마 색상 스와치 -->
        <div class="top-nav__theme-switcher" aria-label="테마 색상 선택">
          <label class="theme-swatch theme-swatch--dark" for="theme-1" title="GitHub Dark"></label>
          <label class="theme-swatch theme-swatch--light"  for="theme-6" title="GitHub Light"></label>
        </div>

        <div class="top-nav__forecast" aria-label="주간 날씨">
          <div class="top-nav__forecast-item" *ngFor="let offset of forecastDayOffsets">
            <span class="top-nav__forecast-label">{{ currentDate.getTime() + 86400000 * offset | date: 'EEE' }}</span>
            <ng-container *ngTemplateOutlet="weatherIcon; context: { kind: getForecastWeather(offset).kind, className: 'top-nav__forecast-icon' }"></ng-container>
          </div>
        </div>
        <div class="top-nav__status">
          <div class="top-nav__clock">
            <div
              class="top-nav__clock-weather"
              [ngClass]="'top-nav__clock-weather--' + currentWeather.kind"
              aria-label="날씨"
            >
              <div class="top-nav__weather-scene" aria-hidden="true">
                <ng-container [ngSwitch]="currentWeather.kind">
                  <ng-container *ngSwitchCase="'clear'">
                    <span class="top-nav__sun-glow"></span>
                    <span class="top-nav__sun-beam top-nav__sun-beam--a"></span>
                    <span class="top-nav__sun-beam top-nav__sun-beam--b"></span>
                    <span class="top-nav__sun-beam top-nav__sun-beam--c"></span>
                    <span class="top-nav__sun-beam top-nav__sun-beam--d"></span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'rain'">
                    <span class="top-nav__weather-tint top-nav__weather-tint--rain"></span>
                    <span class="top-nav__raindrop" *ngFor="let d of weatherRainDrops" [style.left.%]="d.left" [style.animationDelay.s]="d.delay" [style.animationDuration.s]="d.duration"></span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'snow'">
                    <span class="top-nav__weather-tint top-nav__weather-tint--snow"></span>
                    <span class="top-nav__snowflake" *ngFor="let d of weatherRainDrops" [style.left.%]="d.left" [style.animationDelay.s]="d.delay"></span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'cloudy'">
                    <span class="top-nav__weather-tint top-nav__weather-tint--cloudy"></span>
                    <span class="top-nav__cloud top-nav__cloud--a"></span>
                    <span class="top-nav__cloud top-nav__cloud--b"></span>
                    <span class="top-nav__cloud top-nav__cloud--c"></span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'partly-cloudy'">
                    <span class="top-nav__weather-tint top-nav__weather-tint--partly"></span>
                    <span class="top-nav__sun-glow top-nav__sun-glow--soft"></span>
                    <span class="top-nav__cloud top-nav__cloud--a top-nav__cloud--light"></span>
                    <span class="top-nav__cloud top-nav__cloud--b top-nav__cloud--light"></span>
                  </ng-container>
                </ng-container>
              </div>
              <svg class="top-nav__clock-weather-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <ng-container [ngSwitch]="currentWeather.kind">
                  <ng-container *ngSwitchCase="'clear'">
                    <circle class="weather-icon__sun-core" cx="12" cy="12" r="4" fill="currentColor"/>
                    <g class="weather-icon__sun-rays">
                      <path d="M12 2v2"/><path d="M12 20v2"/>
                      <path d="M4.93 4.93l1.41 1.41"/><path d="M17.66 17.66l1.41 1.41"/>
                      <path d="M2 12h2"/><path d="M20 12h2"/>
                      <path d="M4.93 19.07l1.41-1.41"/><path d="M17.66 6.34l1.41-1.41"/>
                    </g>
                  </ng-container>
                  <ng-container *ngSwitchCase="'partly-cloudy'">
                    <circle cx="8" cy="9" r="3"/>
                    <path d="M8 3v1.5M8 15v1.5M3.5 9h1.5M12.5 9h1.5"/>
                    <path d="M17 14h-1.1A5.5 5.5 0 1 0 10 14h7a3.5 3.5 0 0 0 0-7 3.4 3.4 0 0 0-.65 0"/>
                  </ng-container>
                  <ng-container *ngSwitchCase="'cloudy'">
                    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
                  </ng-container>
                  <ng-container *ngSwitchCase="'rain'">
                    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
                    <path d="M8 19v2M12 19v2M16 19v2"/>
                  </ng-container>
                  <ng-container *ngSwitchCase="'snow'">
                    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
                    <path d="M8 19h.01M12 19h.01M16 19h.01"/>
                  </ng-container>
                </ng-container>
              </svg>
              <span class="top-nav__clock-weather-label">{{ currentWeather.label }}</span>
            </div>
            <div class="top-nav__clock-divider" aria-hidden="true"></div>
            <div class="top-nav__clock-info">
              <time class="top-nav__clock-time">{{ currentDate | date: 'HH:mm' }}</time>
              <span class="top-nav__clock-date">{{ currentDate | date: 'yyyy.MM.dd' }}&nbsp;{{ currentDate | date: 'EEEE' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="top-nav__account">
        <a
          class="top-nav__avatar"
          href="javascript:void(0)"
          [class.top-nav__avatar--hidden]="!navigation?.userInfo?.name"
          [class.top-nav__avatar--active]="isNavActive('/my-info')"
          title="내 정보"
          aria-label="내 정보"
          (click)="goToLink('/my-info'); $event.preventDefault()"
        >
          <span>{{ (navigation?.userInfo?.name || '?') | slice: 0:1 }}</span>
        </a>
        <a
          class="top-nav__logout"
          href="javascript:void(0)"
          aria-label="로그아웃"
          (click)="signOut(); $event.preventDefault()"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </a>
      </div>
    </div>
  </header>

  <aside *ngIf="showTopNav && hasSideNav" class="side-subnav" aria-label="서브 네비게이션">
    <label class="side-subnav__collapse" for="app-shell-nav-toggle" aria-label="사이드 메뉴 닫기">
      <span class="side-subnav__collapse-icon" aria-hidden="true">
        <svg
          class="side-subnav__collapse-svg"
          width="30"
          height="16"
          viewBox="0 0 30 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="side-subnav__collapse-chevron side-subnav__collapse-chevron--1"
            d="M9 1.5 L2.5 8 L9 14.5"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            class="side-subnav__collapse-chevron side-subnav__collapse-chevron--2"
            d="M17 1.5 L10.5 8 L17 14.5"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            class="side-subnav__collapse-chevron side-subnav__collapse-chevron--3"
            d="M25 1.5 L18.5 8 L25 14.5"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </label>

    <nav
      class="side-subnav__menu"
      *ngIf="isUserSection()"
      aria-label="사용자 서브메뉴"
    >
      <a
        *ngIf="showMenu('/user/organization')"
        class="side-subnav__link"
        [class.side-subnav__link--active]="isNavActive('/user/organization')"
        href="javascript:void(0)"
        (click)="goToLink('/user/organization'); $event.preventDefault()"
      >
        <span>조직관리</span>
      </a>
      <a
        *ngIf="showMenu('/user/management')"
        class="side-subnav__link"
        [class.side-subnav__link--active]="isNavActive('/user/management')"
        href="javascript:void(0)"
        (click)="goToLink('/user/management'); $event.preventDefault()"
      >
        <span>사용자관리</span>
      </a>
    </nav>

    <nav
      class="side-subnav__menu"
      *ngIf="navigation?.currentUrl?.startsWith('/visit')"
      aria-label="방문증 서브메뉴"
    >
      <a
        *ngIf="showMenu('/visit/visit-info')"
        class="side-subnav__link"
        [class.side-subnav__link--active]="isNavActive('/visit/visit-info')"
        href="javascript:void(0)"
        (click)="goToLink('/visit/visit-info'); $event.preventDefault()"
      >
        <span>방문증관리</span>
      </a>
      <a
        *ngIf="showMenu('/visit/visit-entrance')"
        class="side-subnav__link"
        [class.side-subnav__link--active]="isNavActive('/visit/visit-entrance')"
        href="javascript:void(0)"
        (click)="goToLink('/visit/visit-entrance'); $event.preventDefault()"
      >
        <span>방문증 출입이력</span>
      </a>
    </nav>

    <nav
      class="side-subnav__menu"
      *ngIf="navigation?.currentUrl?.startsWith('/access')"
      aria-label="출입관리 서브메뉴"
    >
      <a class="side-subnav__link" *ngIf="showMenu('/access/permission')"
         href="javascript:void(0)"
         [class.side-subnav__link--active]="isNavActive('/access/permission')"
         (click)="goToLink('/access/permission'); $event.preventDefault()">
        <span>출입권한</span>
      </a>
      <a class="side-subnav__link" *ngIf="showMenu('/access/history')"
         href="javascript:void(0)"
         [class.side-subnav__link--active]="isNavActive('/access/history')"
         (click)="goToLink('/access/history'); $event.preventDefault()">
        <span>출입이력</span>
      </a>
    </nav>

    <nav
      class="side-subnav__menu"
      *ngIf="isAdminSection()"
      aria-label="관리자 서브메뉴"
    >
      <a
        *ngIf="showMenu('/admin/settings')"
        class="side-subnav__link"
        data-admin-nav="settings"
        [class.side-subnav__link--active]="isNavActive('/admin/settings')"
        href="javascript:void(0)"
        (click)="goToLink('/admin/settings'); $event.preventDefault()"
      >
        <span>설정</span>
      </a>
      <a
        *ngIf="showMenu('/admin/management')"
        class="side-subnav__link"
        data-admin-nav="mgmt"
        [class.side-subnav__link--active]="isNavActive('/admin/management')"
        href="javascript:void(0)"
        (click)="goToLink('/admin/management'); $event.preventDefault()"
      >
        <span>관리자관리</span>
      </a>
      <a
        *ngIf="showMenu('/admin/key-management')"
        class="side-subnav__link"
        data-admin-nav="key"
        href="javascript:void(0)"
        [class.side-subnav__link--active]="isNavActive('/admin/key-management')"
        (click)="goToLink('/admin/key-management', 'key-tab-management'); $event.preventDefault()"
      >
        <span>키관리</span>
      </a>
      <a
        *ngIf="showMenu('/admin/system-log')"
        class="side-subnav__link"
        data-admin-nav="system-log"
        href="javascript:void(0)"
        [class.side-subnav__link--active]="isNavActive('/admin/system-log')"
        (click)="goToLink('/admin/system-log'); $event.preventDefault()"
      >
        <span>시스템로그</span>
      </a>
    </nav>

  </aside>

  <div class="app-shell__outlet" [class.app-shell__outlet--no-top]="!showTopNav">
    <common-breadcrumb
      *ngIf="showTopNav && !isDashboard && (breadcrumbItems$ | async)?.length"
      [items]="(breadcrumbItems$ | async) || []"
    ></common-breadcrumb>
    <router-outlet></router-outlet>
    <footer *ngIf="showTopNav && !isDashboard" class="app-footer">
      <div class="app-footer__inner">
        <img class="app-footer__logo" src="assets/images/logo.png" alt="kt alpha" />
        <span class="app-footer__divider" aria-hidden="true">|</span>
        <span class="app-footer__copy">Copyright 2026. kt alpha Co., Ltd. All Rights Reserved.</span>
        <span class="app-footer__divider" aria-hidden="true">|</span>
        <span class="app-footer__info">kt alpha 출입통제시스템</span>
      </div>
    </footer>
  </div>

  <!-- 날씨 아이콘 (상태별) -->
  <ng-template #weatherIcon let-kind="kind" let-className="className">
    <svg [class]="className" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <ng-container [ngSwitch]="kind">
        <!-- 맑음 -->
        <ng-container *ngSwitchCase="'clear'">
          <circle cx="12" cy="12" r="4" fill="currentColor"/>
          <g class="weather-icon__sun-rays">
            <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>
          </g>
        </ng-container>
        <!-- 구름 조금 -->
        <ng-container *ngSwitchCase="'partly-cloudy'">
          <circle cx="8" cy="9" r="3"/>
          <path d="M8 3v1.5M8 15v1.5M3.5 9h1.5M12.5 9h1.5"/>
          <path d="M17 14h-1.1A5.5 5.5 0 1 0 10 14h7a3.5 3.5 0 0 0 0-7 3.4 3.4 0 0 0-.65 0"/>
        </ng-container>
        <!-- 흐림 -->
        <ng-container *ngSwitchCase="'cloudy'">
          <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
        </ng-container>
        <!-- 비 -->
        <ng-container *ngSwitchCase="'rain'">
          <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
          <path d="M8 19v2M12 19v2M16 19v2"/>
        </ng-container>
        <!-- 눈 -->
        <ng-container *ngSwitchCase="'snow'">
          <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
          <path d="M8 19h.01M12 19h.01M16 19h.01"/>
        </ng-container>
      </ng-container>
    </svg>
  </ng-template>
</div>
